import React, { Component } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  createManufacturerCode,
  fetchManufacturerCodeList,
  updateFiltersForManufacturerCodeList,
  sortManufacturerCodeList,
  clearManufacturerCodeFilters,
  deleteManufacturerCode,
} from "../../actions/manufacturerCodeAction";
import Button from "@material-ui/core/Button";
import { validateAuthority } from "../../utils/utils";
import { showError } from "../../actions/commonActions";
import { Box } from "@material-ui/core";
import DataTable from "../../components/DataTable";
import { AUTHORITY_ADMIN } from "../../constant";
import PageTemplate from "../../components/PageTemplate";
import { NoteAdd } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import ManufacturerCodeDeleteDialog from "../../components/dialogs/ManufacturerCode/ManufacturerCodeDeleteDialog";
import ManufacturerCodeCreateDialog from "../../components/dialogs/ManufacturerCode/ManufacturerCodeCreateDialog";

class ManufacturerCodeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showContentLoader: false,
      filters: {
        manufacturerCode: "",
        createdAt: {
          from: null,
          to: null,
        },
      },
      openDeleteDialog: false,
    };
  }

  componentDidMount() {
    this.props.fetchManufacturerCodeList(
      "orderBy=createdAt&sort=desc&filterFields[]=active&filterValues[]=true",
    );
    this.props.clearManufacturerCodeFilters();
    this.props.sortManufacturerCodeList("createdAt", "desc");
  }

  validateManufacturerCode = (value) => {
    const regex = /^[a-z0-9]+$/;
    return regex.test(value);
  };

  handleAdd = async () => {
    const { manufacturerCode } = this.state;

    this.setState({ error: "" });

    if (!manufacturerCode) {
      this.setState({ error: "Manufacturer code is required." });
      return;
    }

    if (!this.validateManufacturerCode(manufacturerCode)) {
      this.setState({
        error:
          "Manufacturer code must contain only lowercase letters and numbers.\nNo spaces or special characters allowed.",
      });
      return;
    }

    const isDuplicate = this.props.manufacturerCode.some(
      (item) => item.manufacturerCode?.toLowerCase() === manufacturerCode.toLowerCase()
    );
    if (isDuplicate) {
      this.setState({ error: "Manufacturer code already exists." });
      return;
    }

    try {
      this.setState({ showContentLoader: true });
      await this.props.createManufacturerCode(manufacturerCode);
      await this.props.fetchManufacturerCodeList(
        "orderBy=createdAt&sort=desc&filterFields[]=active&filterValues[]=true",
      );
      this.handleClose();
    } catch (err) {
      this.props.showError({
        response: {
          data: {
            translationKey: err?.message || "Create failed. Please try again.",
          },
        },
      });
    } finally {
      this.setState({ showContentLoader: false });
    }
  };

  openModel = () => {
    this.setState({ openModel: true });
  };

  handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    this.setState({ openModel: false });
  };

  openDeleteDialog = (row) => {
    this.setState({
      openDeleteDialog: true,
      selectedRow: row,
    });
  };

  handleDeleteCancel = () => {
    this.setState({
      openDeleteDialog: false,
      selectedRow: null,
    });
  };

  handleDeleteConfirm = async () => {
    const { selectedRow } = this.state;
    if (!selectedRow) return;

    try {
      this.setState({ showContentLoader: true });
      await this.props.deleteManufacturerCode(selectedRow.manufacturerCode);
      await this.props.fetchManufacturerCodeList(
        "orderBy=createdAt&sort=desc&filterFields[]=active&filterValues[]=true",
      );
      this.setState({ openDeleteDialog: false, selectedRow: null });
    } catch (err) {
      this.props.showError({
        response: {
          data: {
            translationKey: err?.message || "Delete failed. Please try again.",
          },
        },
      });
    } finally {
      this.setState({ showContentLoader: false });
    }
  };

  handleFilterUpdate = (filterKey, filterValue, multipleSelection) => {
    if (multipleSelection) {
      let filterState = this.props.manufacturerCodeFilters[filterKey] || [];
      filterState.includes(filterValue)
        ? filterState.splice(filterState.indexOf(filterValue), 1)
        : filterState.push(filterValue);
      filterValue = filterState;
    }

    this.props.updateFiltersForManufacturerCodeList(filterKey, filterValue);
  };

  handleFilterReset = () => {
    this.props.clearManufacturerCodeFilters();
    this.props.fetchManufacturerCodeList(
      "orderBy=createdAt&sort=desc&filterFields[]=active&filterValues[]=true",
    );
  };

  handleSorting = (orderBy, sort) => {
    this.props.sortManufacturerCodeList(orderBy, sort);

    const query = this.buildFilterQuery(
      this.props.manufacturerCodeFilters,
      orderBy,
      sort,
    );

    this.props.fetchManufacturerCodeList(query);
  };

  buildFilterQuery = (filters, orderBy = "createdAt", sort = "desc") => {
    const filtersWithActive = {
      ...filters,
      active: true,
    };
    const params = new URLSearchParams();

    Object.entries(filtersWithActive).forEach(([key, value]) => {
      if (value === null || value === "" || value === undefined) return;

      if (typeof value === "object" && ("from" in value || "to" in value)) {
        if (value.from) {
          params.append("filterFields[]", `${key}.from`);
          params.append("filterValues[]", value.from);
        }
        if (value.to) {
          params.append("filterFields[]", `${key}.to`);
          params.append("filterValues[]", value.to);
        }
      } else {
        params.append("filterFields[]", key);
        params.append("filterValues[]", value);
      }
    });

    return `orderBy=${orderBy}&sort=${sort}&${params.toString()}`;
  };

  render() {
    const fields = [
      { name: "manufacturerCode" },
      { name: "creator.name" },
      { name: "createdAt" },
      {
        name: "delete",
        type: "action",
        sorting: false,
        render: (row) => (
          <IconButton
            size="small"
            onClick={(e) => {
              e.preventDefault();
              this.openDeleteDialog(row);
            }}
          >
            <DeleteIcon />
          </IconButton>
        ),
      },
    ];

    const filterKeys = [
      {
        name: "manufacturerCode",
        type: "textField",
      },
      {
        name: "createdAt",
        type: "dateRangePicker",
      },
    ];
    const MenuBar = () => {
      const { t } = useTranslation();
      return (
        <div
          style={{
            paddingTop: 30,
            paddingLeft: 30,
            paddingRight: 30,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {validateAuthority(
            AUTHORITY_ADMIN,
            this.props.authentication.loggedInUser.authorities,
          ) && (
            <Button
              size="small"
              variant="contained"
              color="secondary"
              style={{
                background: "#E3D900",
                padding: "16px",
              }}
              onClick={this.openModel}
            >
              {t("messages.createManufacturerCode")}
              <NoteAdd style={{ marginLeft: "8px" }} />
            </Button>
          )}
        </div>
      );
    };

    return (
      <>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <h3 style={{ paddingLeft: 30, paddingTop: 30 }}>
            {"Manufacturer Code"}
          </h3>
          <MenuBar></MenuBar>
        </Box>

        <PageTemplate>
          <DataTable
            fields={fields}
            items={this.props.manufacturerCode}
            entity="manufacturerCode"
            filterKeys={filterKeys}
            filterValues={this.props.manufacturerCodeFilters}
            onInputChange={this.handleFilterUpdate}
            onValueSubmit={() => {
              const query = this.buildFilterQuery(
                this.props.manufacturerCodeFilters,
              );
              this.props.fetchManufacturerCodeList(query);
            }}
            sorting={this.props.manufacturerCodeSorting}
            sortingAvailable={true}
            onSort={(columnName, dir) => this.handleSorting(columnName, dir)}
            onCancel={this.handleFilterReset}
            showContentLoader={this.state?.showContentLoader}
            enableFilter={true}
            disableCell={true}
          />

          <ManufacturerCodeCreateDialog
            open={this.state.openModel}
            manufacturerCode={this.state.manufacturerCode}
            error={this.state.error}
            onChange={(e) =>
              this.setState({ manufacturerCode: e.target.value, error: "" })
            }
            onCancel={this.handleClose}
            onAdd={this.handleAdd}
          />

          <ManufacturerCodeDeleteDialog
            open={this.state.openDeleteDialog}
            manufacturerCode={this.state.selectedRow?.manufacturerCode}
            onCancel={this.handleDeleteCancel}
            onConfirm={this.handleDeleteConfirm}
          />
        </PageTemplate>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  manufacturerCode: state.manufacturerCode.list || [],
  manufacturerCodeUploadDialog:
    state.manufacturerCode.manufacturerCodeUploadDialog,
  manufacturerCodeSorting: state.manufacturerCode.sorting || {
    column: null,
    direction: null,
  },
  manufacturerCodeFilters: state.manufacturerCode.filters || {
    active: true,
    manufacturerCode: "",
  },
  authentication: state.authentication,
});

export default connect(mapStateToProps, {
  createManufacturerCode,
  fetchManufacturerCodeList,
  updateFiltersForManufacturerCodeList: updateFiltersForManufacturerCodeList,
  clearManufacturerCodeFilters: clearManufacturerCodeFilters,
  showError,
  sortManufacturerCodeList,
  deleteManufacturerCode,
})(ManufacturerCodeList);
